module.exports = __webpack_public_path__ + "static/media/superare-logo.b6d5bca5.png";